"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactBlueprintLibrary = require("react-blueprint-library");
var _conditionalRendering = require("./conditionalRendering");
var _checkConditions = require("./checkConditions");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
var CustomTelephone = props => {
  var feedbackType = '',
    helperText = '',
    css = props.field.model.cssClass,
    shouldHide,
    showRequired = '';
  if (props.errors.length > 0) {
    feedbackType = 'invalid';
    css = css + ' is-invalid';
    props.errors.map((error, index) => /*#__PURE__*/_react.default.createElement("div", {
      className: "invalid-feedback",
      key: index
    }, helperText = error));
  }
  var field = props.field,
    fieldId = field.valueField.id,
    fieldName = field.valueField.name,
    state = _conditionalRendering.store.getState();
  var [selection, setSelection] = (0, _react.useState)({
    start: 0,
    end: 0,
    inputRef: null
  });

  // setup for if the field is required
  if (field.model.required) {
    showRequired = "*";
  }
  var onChange = e => {
    var val = e.target.value.replace(/\D/g, '');
    var len = val.length;
    switch (len) {
      case 1:
        val = val.replace(/^(\d{1})/, "($1)");
        break;
      case 2:
        val = val.replace(/^(\d{2})/, "($1)");
        break;
      case 3:
        val = val.replace(/^(\d{3})/, "($1)");
        break;
      case 4:
        val = val.replace(/^(\d{3})(\d{1})/, "($1) $2");
        break;
      case 5:
        val = val.replace(/^(\d{3})(\d{2})/, "($1) $2");
        break;
      case 6:
        val = val.replace(/^(\d{3})(\d{3})/, "($1) $2");
        break;
      case 7:
        val = val.replace(/^(\d{3})(\d{3})(.+)/, "($1) $2-$3");
        break;
      case 8:
        val = val.replace(/^(\d{3})(\d{3})(.+)/, "($1) $2-$3");
        break;
      default:
        val = val.replace(/^(\d{3})(\d{3})(.+)/, "($1) $2-$3");
        break;
    }
    var newValue = val.substring(0, 14);
    var fieldKey = field.model.conditionSettings.fieldKey;
    if (state !== undefined) {
      state.fieldValues[fieldKey] = newValue;
    }
    var valid = true,
      errorMessages = [];
    if (field.model.required && !newValue) {
      valid = false;
      errorMessages.push(field.model.title + ' is required');
    }
    var start = len > 3 ? len > 6 ? len + 4 : len + 3 : len + 1;
    var selectionStart = e.currentTarget.selectionStart;
    var placement = start >= selectionStart && selectionStart !== len ? selectionStart : start;
    if ((selectionStart === 6 || selectionStart === 5) && len === 4) placement = 7;
    if (selectionStart === 4 && len === 3) placement = 5;
    if (selectionStart === 10 && len === 7) placement = 11;
    if (selectionStart === 8 && len === 6) placement = 9;
    setSelection({
      start: placement,
      end: placement,
      inputRef: e.currentTarget
    });
    props.onChange(fieldName, newValue, valid, errorMessages);
  };
  (0, _react.useEffect)(() => {
    if (!selection) return;
    var {
      start,
      end,
      inputRef
    } = selection;
    if (inputRef) inputRef.setSelectionRange(start, end);
  }, [selection]);
  var conditionId = field.model.conditionSettings.fieldKey;
  if (state !== undefined) {
    if (state.conditions[conditionId] !== undefined) shouldHide = (0, _checkConditions.checkConditions)(state.fieldValues, state.conditions[conditionId]);
    var hideArray = state.hiddenFields;
    if (shouldHide) {
      if (hideArray.indexOf(fieldName) === -1) {
        hideArray.push(fieldName);
      }
    } else {
      if (hideArray.indexOf(fieldName) > -1) {
        hideArray = hideArray.filter(e => e !== fieldName);
      }
    }
    state.hiddenFields = hideArray;
  }
  if (shouldHide) {
    return null;
  } else {
    return /*#__PURE__*/_react.default.createElement("div", {
      className: "mm-spacing--minor"
    }, /*#__PURE__*/_react.default.createElement(_reactBlueprintLibrary.FormInput, {
      id: fieldId,
      name: fieldName,
      className: css,
      labelText: props.field.model.title !== '' ? props.field.model.title + showRequired : undefined,
      feedbackType: feedbackType !== '' ? feedbackType : undefined,
      maxLength: props.field.model.maxLength,
      placeholderText: props.field.model.placeholderText,
      helperText: helperText,
      onChange: onChange,
      value: props.value
    }));
  }
};
var _default = exports.default = CustomTelephone;